import React, {Component} from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {Grid, GridColumn} from '@atlaskit/page';
import ContentWrapper from '../../components/ContentWrapper';
import styled from 'styled-components';
import {connect} from 'react-redux';
import NotificationActions from '../../redux/NotificationRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import {FieldWrapper, TextField, TextAreaField, TableField} from '../../components/FormFields';
import {DateTimePicker} from '@atlaskit/datetime-picker';
import Select from '@atlaskit/select';
import NotificationType from './components/NotificationType';
import Spinner from '@atlaskit/spinner';
import Forbidden from '../../components/Forbidden';
import {withTranslation, Trans} from 'react-i18next';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const NotificationTypesContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const DATE_START_OPTIONS=[
  {label: 'Now', value: false},
  {label: 'Plan', value: true},
];

class NotificationPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showStartTime: false,
      notification: {
        title: '',
        description: '',
        startTime: null,
        rules: [],
        msgs: {}
      },
    };
  }

  componentDidMount() {
    if (!this.props.dictionaries.mailingTypes.data) {
      this.props.getDictionaries('mailingTypes');
    }
    if (this.props.match.params.id !== 'new') {
      this.props.get(this.props.match.params.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching !== this.props.fetching
      && prevProps.fetching) {
        if (!this.props.error) {
          if (prevProps.notification
            && !this.props.notification) {
              //отчет был удален
              this.props.history.goBack();
          } else if (this.props.match.params.id === 'new'
            && this.props.notification) {
              //отчет был добавлен
              this.props.history.goBack();
          } else {
            //даные отчета загружены
            const {title, description, startTime, rules, msgs} = this.props.notification;
            let data = {
              title,
              description,
              startTime,
              rules,
              msgs: {}
            };
            if (msgs && msgs.length) {
              msgs.map(msg => data.msgs[msg.type] = {...msg})
            }
            this.setState({
              showStartTime: !!data.startTime,
              notification: data,
            });
          }
        
        } else if (!this.state.notification.title) {
          //произошла ошибка - отчет не найден, другие ошибки выводим глобально
          this.props.history.goBack();
        }
    }
  }

  onDelete = e => {
    e.preventDefault();
    this.props.delete(this.props.notification.id);
  }

  onCancel = e => {
    e.preventDefault();
    this.props.history.goBack();
  }

  onFormSubmit = e => {
    e.preventDefault();
    const {notification} = this.state;
    if (this.props.match.params.id === 'new'
      && notification.msgs
      && Object.keys(notification.msgs).length > 0) {
      this.props.create({...notification, msgs: Object.keys(notification.msgs).map(key => ({...notification.msgs[key], type: key}))})
    } else {
      //waranty: Должен быть вывод ошибки, так как из required для select не работает.
    }
  }

  onCreateNew = e => {
    e.preventDefault();
    this.props.history.replace('/notifications/new');
  }

  onChange = (name, value) => {
    if (name.includes('msgs.')) {
      const path = name.split('.');
      if (path.length === 3) {
        let obj = {...this.state.notification[path[0]]};
        obj[path[1]][path[2]] = value;
        this.setState({
          notification: {...this.state.notification, [path[0]]: obj},
        });
      }
    } else {
      this.setState({
        notification: {...this.state.notification, [name]: value},
      });
    }
  }

  render() {
    const isNew = this.props.match.params.id === 'new';
    const {notification, showStartTime} = this.state;
    const {
      fetching,
      dictionaries,
      getDictionaries,
      permissions,
      t,
    } = this.props;
    
    if (!permissions) {
      return <Forbidden />;
    } else if (isNew && !permissions.create) {
      return <Forbidden />;
    }

    const disabled = fetching || !isNew;

    return (
      <ContentWrapper>
        <HeaderContainer>
          <h1>{t(isNew ? 'New campaign' : 'Campaign')}</h1>
          {!isNew && permissions.create &&(
            <Button
              appearance='danger'
              onClick={this.onCreateNew}
            >
              {t('New campaign')}
            </Button>
          )}
        </HeaderContainer>
        <form onSubmit={this.onFormSubmit}>
          <Grid>
            <GridColumn medium={12}>
              <TextField
                name='title'
                label={t('Title')}
                placeholder={t('Enter campaign title')}
                required={true}
                onChange={this.onChange}
                isDisabled={disabled}
                value={notification.title}
              />
            </GridColumn>
            <GridColumn medium={12}>
              <TextAreaField
                name='description'
                label={t('Description')}
                placeholder={t('Enter campaign description')}
                onChange={this.onChange}
                isDisabled={disabled}
                value={notification.description}
              />
            </GridColumn>
            <GridColumn medium={12}>
              <FieldWrapper
                name='dateStart'
                label={t('Planning')}
              >
                <Grid>
                  <GridColumn medium={6}>
                    <Select
                      value={DATE_START_OPTIONS.find(option => option.value === showStartTime)}
                      options={DATE_START_OPTIONS}
                      styles={{
                        valueContainer: base => ({
                          ...base,
                          minHeight: '40px',
                        }),
                      }}
                      onChange={({value}) => {
                        this.setState({showStartTime: value});
                        this.onChange('startTime', value ? Date.now() : null)
                      }
                      }
                      getOptionLabel={option => t(option.label)}
                      isDisabled={disabled}
                    />
                  </GridColumn>
                  <GridColumn medium={6}>
                    {showStartTime && (
                      <DateTimePicker
                        locale='ru'
                        value={notification.startTime}
                        onChange={value => this.onChange('startTime', value)}
                        isDisabled={disabled}
                      />
                    )}
                  </GridColumn>
                </Grid>
              </FieldWrapper>
            </GridColumn>
            <GridColumn medium={12}>
              <TableField
                name='rules'
                label={t('Recipients')}
                value={notification.rules}
                onChange={this.onChange}
                fields={dictionaries.fields.data && [...dictionaries.fields.data.filter(itm => itm.forMailing === true)]}
                operators={dictionaries.operators.data && [...dictionaries.operators.data]}
                andOr={dictionaries.andOr.data && [...dictionaries.andOr.data]}
                getDictionaries={getDictionaries}
                isDisabled={disabled}
              />
            </GridColumn>
            <GridColumn medium={12}>
              <FieldWrapper
                name='msgs'
                label={t('Campaigns')}
                required={true}
              >
                <NotificationTypesContainer>
                  {dictionaries.mailingTypes.data ? dictionaries.mailingTypes.data.map(mailingType => (
                    <NotificationType
                      key={`notification_type_${mailingType.id}`}
                      active={!!notification.msgs[mailingType.id]}
                      id={mailingType.id}
                      name={mailingType.name}
                      /*
                      recepients={1000000}
                      total={1000000}
                      */
                      onClick={e => {
                        e.preventDefault();
                        if (disabled)
                         return;
                        let value = {...notification.msgs};
                        if (value[mailingType.id]) {
                          delete value[mailingType.id];
                        } else {
                          let obj = {};
                          mailingType.fields && mailingType.fields.map(field => {obj[field.id]=''});
                          value[mailingType.id] = obj;
                        }
                        
                        this.onChange('msgs', value);
                      }}
                    />
                  )) : (
                    <Spinner />
                  )}
                </NotificationTypesContainer>
              </FieldWrapper>
            </GridColumn>
            {dictionaries.mailingTypes.data && dictionaries.mailingTypes.data.map(mailingType => notification.msgs[mailingType.id] && (
              <GridColumn key={`msgs_group_${mailingType.id}`} medium={12}>
                <h5 style={{paddingTop: 16}}>{mailingType.name}</h5>
                {mailingType.fields.map(field => {
                  const Element = field.type === 'area' ? TextAreaField : TextField;
                  return (
                    <Element
                      key={`msgs.${mailingType.id}.${field.id}`}
                      name={`msgs.${mailingType.id}.${field.id}`}
                      label={field.title}
                      required={field.isRequired}
                      onChange={this.onChange}
                      placeholder={`Введите ${field.title.toLowerCase()}`}
                      value={notification.msgs[mailingType.id][field.id]}
                      maxLength={field.maxLength}
                      isDisabled={disabled}
                    />
                  )})
                }
              </GridColumn>
            ))}
            <GridColumn medium={12}>
              <FormFooter>
                <ButtonGroup>
                  {!isNew && permissions.delete && <Button appearance='subtle' isDisabled={fetching} onClick={this.onDelete}><span style={{color: !fetching && 'red'}}><Trans>Remove</Trans></span></Button>}
                  <Button appearance='subtle' isDisabled={fetching} onClick={this.onCancel}>
                    <Trans>{isNew ? 'Cancel' : 'Close'}</Trans>
                  </Button>
                  {isNew && (
                    <Button
                      type='submit' 
                      isDisabled={disabled} 
                      isLoading={fetching} 
                      appearance='danger'
                    >
                      {t('Start')}
                    </Button>
                  )}
                </ButtonGroup>
              </FormFooter>
            </GridColumn>
          </Grid>
        </form>
      </ContentWrapper>
    );
  }
}
const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions.mailing,
    notification: state.notification.data,
    fetching: state.notification.fetching,
    error: state.notification.error,
    dictionaries: state.dictionaries, 
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get: id => dispatch(NotificationActions.notificationRequest(id)),
    create: data => dispatch(NotificationActions.notificationAddRequest(data)),
    delete: id => dispatch(NotificationActions.notificationDeleteRequest(id)),
    getDictionaries: name => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default withTranslation('notifications', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationPage));
